<template>
  <div>
    <v-menu center left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="handleClick(index)"
        >
          <v-list-item-icon>
            <v-icon :color="item.color">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title :style="{ color: item.color }"
            >{{ item.title }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="dialogs.delete = true">
          <v-list-item-icon>
            <v-icon color="#EC4A4A">mdi-trash-can</v-icon>
          </v-list-item-icon>
          <v-list-item-title style="color: #ec4a4a">Delete</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <DialogMember
      @close="dialogs.member = false"
      v-if="dialogs.member"
      :group="group"
    />
    <DialogMembers
      @close="dialogs.members = false"
      v-if="dialogs.members"
      :group="group"
    />
    <DialogEdit
      @close="dialogs.edit = false"
      v-if="dialogs.edit"
      :group="group"
    />
    <DialogDelete
      @close="dialogs.delete = false"
      v-if="dialogs.delete"
      :group="group"
    />
  </div>
</template>

<script>
import DialogMembers from "../Dialogs/GroupMembers";
import DialogMember from "../Dialogs/GroupAddMember";
import DialogEdit from "../Dialogs/GroupEdit";
import DialogDelete from "../Dialogs/GroupDelete";

export default {
  props: ["group"],
  components: {
    DialogMember,
    DialogMembers,
    DialogEdit,
    DialogDelete,
  },
  data: () => ({
    dialogs: {
      member: false,
      members: false,
      edit: false,
      delete: false,
    },
    items: [
      {
        title: "Add member",
        icon: "mdi-account",
        color: "grey3",
        click() {
          this.dialogs.member = true;
        },
      },
      {
        title: "Members",
        icon: "mdi-account-multiple",
        color: "grey3",
        click() {
          this.dialogs.members = true;
        },
      },
      {
        title: "Edit",
        icon: "mdi-pencil",
        color: "grey3",
        click() {
          this.dialogs.edit = true;
        },
      },
    ],
  }),
  methods: {
    toggleUserStatus(obj) {
      this.items.push(obj);
    },
    handleClick(index) {
      this.items[index].click.call(this);
    },
  },
};
</script>
